export const adminConstants = {
  GETALL_REQUEST: 'ADMINS_GETALL_REQUEST',
  GETALL_SUCCESS: 'ADMINS_GETALL_SUCCESS',
  GETALL_FAILURE: 'ADMINS_GETALL_FAILURE',

  GET_REQUEST: 'ADMINS_GET_REQUEST',
  GET_SUCCESS: 'ADMINS_GET_SUCCESS',
  GET_FAILURE: 'ADMINS_GET_FAILURE',

  ADD_REQUEST: 'ADMINS_ADD_REQUEST',
  ADD_SUCCESS: 'ADMINS_ADD_SUCCESS',
  ADD_FAILURE: 'ADMINS_ADD_FAILURE',

  UPDATE_REQUEST: 'ADMINS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ADMINS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ADMINS_UPDATE_FAILURE',

  ACL_READY: 'ACL_READY',
};
